import styled, { css } from 'styled-components';

import { media, getThemeColor, getThemePath } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Wrapper = styled.div`
  ${({ isBasketVersion }) =>
    isBasketVersion
      ? css`
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 1rem;
          margin-bottom: 1rem;
          border: 0.2rem solid ${getThemeColor('hue.orange')};
          border-radius: ${getThemePath(['borderRadiuses', 'normal.3'])}rem;
          ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 3)}
          ${({ theme }) => theme.getFluidSpacing('padding-right', 'scale', 4)}
        ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 3)}
        ${({ theme }) => theme.getFluidSpacing('padding-left', 'scale', 4)}
        ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)}
        ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 1)}
        `
      : css`
          ${({ theme }) => theme.getFluidSpacing('padding', 'scale', 3)};
          border: 0.2rem solid;
          border-color: ${getThemeColor('bluegrey.80')};
          border-radius: ${({ theme }) => theme.borderRadiuses['normal.2']}rem;

          ${media.from640down`
          padding-left: 2rem;
          padding-right: 2rem;
        `}
        `}
`;

export const Message = styled(Typography).attrs(({ isBasketVersion }) => ({
  customAs: 'p',
  variant: isBasketVersion ? 'body2' : 'h4',
}))`
  margin: 0;
  color: ${({ isBasketVersion }) =>
    isBasketVersion && getThemeColor('hue.orange')};
  text-align: center;
`;
